(function () {
    'use strict';

    angular.module("imApp").factory("stockPlacesToService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 2172,
                    parameters: parms || {}
                });
            },
            listStockPlacesTo: function (parms) {
                return $ihttp.post({
                    method: 2173,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
